var exports = {
  "Y": "AltTextTooltip.module__tooltip___WGFTZF",
  "Q": "AltTextTooltip.module__text___WGFTZF",
};

module.exports = exports;
